export default __webpack_public_path__ + "static/Entenda0000-db8caedee26a3c663dd61a06d7c7c020.jpg";